<template>
  <v-app id="core">
    <router-view />
    <v-overlay :value="isLoading" class="highestmodal">
      <v-progress-circular
        indeterminate
        size="64"
        class="highestmodal"
      ></v-progress-circular>
    </v-overlay>
    <v-row justify="center">
      <v-dialog v-model="isErrored" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">Refresh Required</v-card-title>
          <v-card-text
            >The page you are trying to access has been updated to a new
            version. In order to get this new version refresh the page. If the
            error persists please
            <a href="mailto:support@arist.co">email us</a> and we will take a
            look.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue" depressed dark @click="reload"
              >Reload and Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <signin v-model="open" />
  </v-app>
</template>
<script>
import signin from "@/components/signin-modal";

export default {
  components: {
    signin
  },
  computed: {
    open: {
      get() {
        return this.$store.getters["needauth"];
      },
      set() {
        this.$store.commit("needauth", false);
      }
    },
    isLoading() {
      return this.$store.state.loading;
    },
    isErrored() {
      return this.$store.getters["navigationError"];
    }
  },
  methods: {
    reload() {
      location.reload(true);
    }
  }
};
</script>
<style>
#core {
  font-family: "Questrial" !important;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #c2c9d2;
}
::-webkit-scrollbar-thumb:hover {
  border-radius: 8px;
  background: #adb1b6;
}
.highestmodal {
  z-index: 9999 !important;
}
</style>
